// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface MentorshipItemCreate
 */
export interface MentorshipItemCreate {
    /**
     * 
     * @type {string}
     * @memberof MentorshipItemCreate
     */
    mentorship: string;
    /**
     * 
     * @type {string}
     * @memberof MentorshipItemCreate
     */
    item: string;
}

export function MentorshipItemCreateFromJSON(json: any): MentorshipItemCreate {
    return {
        'mentorship': json['mentorship'],
        'item': json['item'],
    };
}

export function MentorshipItemCreateToJSON(value?: MentorshipItemCreate): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'mentorship': value.mentorship,
        'item': value.item,
    };
}


